var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('t-no-content-panel',{attrs:{"text":_vm.$t('noLoadingInformation'),"icon":"truck-front"}})}
var staticRenderFns = []

export { render, staticRenderFns }